import { apiWithPrefix as api } from '../utils/api';

export class AnnouncementService {
  static async getAnnouncements({ filter = 'all', limit } = {}) {
    const params = { filter };
    if (limit != null) params.limit = limit;
    const response = await api.get('/announcements', { params });
    return response.data;
  }

  static async createAnnouncement(data) {
    const response = await api.post('/announcements', data);
    return response.data;
  }

  static async updateAnnouncement(id, data) {
    const response = await api.put(`/announcements/${id}`, data);
    return response.data;
  }

  static async deleteAnnouncement(id) {
    const response = await api.delete(`/announcements/${id}`);
    return response.data;
  }

  static async markAsRead(id) {
    const response = await api.put(`/announcements/${id}/read`);
    return response.data;
  }
}

export default AnnouncementService;
